export const FolderType = {
  Campaign: 1,
  Copilot: 2,
};
